import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";

export default function WeeklyEnergyTrendCard({ buildingId }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [summary, setSummary] = useState({ thisWeekKwh: 0, lastWeekKwh: 0, absDelta: 0, pctDelta: null });
  const [series, setSeries] = useState([]);
  const [windowInfo, setWindowInfo] = useState(null);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      if (!buildingId) return;
      setLoading(true);
      setError(null);
      try {
        const resp = await axios.get(`/energy/buildings/${buildingId}/weekly-trend`);
        if (cancelled) return;
        const data = resp.data || {};
        setSummary(data.summary || {});
        // reshape series to include both bars
        const s = (data.series || []).map((d) => ({ date: d.date, This: Number(d.kwhThis || 0), Last: Number(d.kwhLast || 0) }));
        setSeries(s);
        setWindowInfo(data.window || null);
      } catch (e) {
        if (!cancelled) setError(e?.message || "Failed to load weekly trend");
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => {
      cancelled = true;
    };
  }, [buildingId]);

  return (
    <div>
      <div style={{ marginBottom: 8 }}>
        {loading ? (
          <span>Loading…</span>
        ) : error ? (
          <span style={{ color: "#c00" }}>{error}</span>
        ) : (
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            <div>
              <strong>This week</strong>: {Number(summary.thisWeekKwh || 0).toFixed(2)} kWh
            </div>
            <div>
              <strong>Last week</strong>: {Number(summary.lastWeekKwh || 0).toFixed(2)} kWh
            </div>
            <div>
              <strong>Δ</strong>: {Number(summary.absDelta || 0).toFixed(2)} kWh
              {summary.pctDelta === null ? "" : ` (${Number(summary.pctDelta).toFixed(2)}%)`}
            </div>
            {windowInfo ? (
              <div style={{ opacity: 0.7 }}>
                {windowInfo.weekStart} → {windowInfo.weekEnd}
              </div>
            ) : null}
          </div>
        )}
      </div>

      <div style={{ width: "100%", height: 260 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={series} margin={{ top: 8, right: 16, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" tick={{ fontSize: 12 }} />
            <YAxis tick={{ fontSize: 12 }} unit=" kWh" />
            <Tooltip formatter={(v) => `${Number(v).toFixed(2)} kWh`} />
            <Legend />
            <Bar dataKey="This" fill="#007bff" radius={[4, 4, 0, 0]} />
            <Bar dataKey="Last" fill="#6c757d" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}


